<template>
<div class="spWithdrawalList">
    <sPWithdrawalList v-if="user.providerstatus == 10" :hostroletype="hostroletype"></sPWithdrawalList>
    <serviceProviderTip v-else></serviceProviderTip>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import SPWithdrawalList from 'views/brandBusiness/capitalMgt/withdrawal/WithdrawalList.vue'
import ServiceProviderTip from 'views/serviceProvider/components/serviceProviderTip.vue'
export default {
    name: 'WithdrawalList',
    data() {
        return {
            hostroletype: 4
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user'])
    },
    components: {
        SPWithdrawalList, ServiceProviderTip
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.spWithdrawalList {
}
</style>
